

import { UIEvent } from 'react'

import { useIsFavorite } from '@entities/Product'

import { FavoriteButton } from '@features/favorite'

import { Product } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import { type ButtonShapeVariant, type ButtonSizeVariant } from '@shared/ui/button'

import CommentButton from '../comment/button'
import DeleteProduct from '../delete-product'

import styles from './styles.module.scss'

export type SupportedActionButtonTypes = 'comment' | 'delete' | 'favorite'

interface ActionButtonsProps {
  product: Product;
  className?: string;
  onRemove: (e: UIEvent, productId: string) => void;
  buttonsTemplate?: SupportedActionButtonTypes[]
  size?: ButtonSizeVariant
  shape?: ButtonShapeVariant
}

export default function ActionButtons ({ product, className, onRemove, buttonsTemplate = [ 'favorite' ], size = 'small', shape = 'square' }: ActionButtonsProps) {
  const isFavorite = useIsFavorite(product.id)

  const renderButtonByType = (type: SupportedActionButtonTypes, key: string) => {
    switch (type) {
    case 'comment': return <CommentButton key={key} size={size} shape={shape} product={product} />
    case 'delete': return <DeleteProduct key={key} size={size} shape={shape} onClick={(e) => onRemove(e, product.id)} />
    case 'favorite': return <FavoriteButton key={key} size={size} shape={shape} id={product.id} isFavorite={isFavorite} appearance='square-button' />
    default: return null
    }
  }

  return (
    <div className={cn(styles.actionButtons, className)}>
      {buttonsTemplate.map((buttonType, index) => renderButtonByType(buttonType, `${buttonType}:${index}`))}
    </div>
  )
}
